// Halloween spiders that scuttle across the screen once per visit
// (season.js calls this for an element with data-season-crawl).
//
// Each spider comes in from one edge and leaves by another, a second or
// so apart, then the layer is removed. Taps pass straight through. Each
// page runs them once per browser session, and only once the tab is on
// screen. Not shown with reduced motion.

const KEY = "gg-crawl-seen";
const SPIDER = `<svg viewBox="0 0 32 28" aria-hidden="true" focusable="false">
<g class="gg-crawl__legs"><path d="M10 9 4 3M9 13 1 11M10 17 2 22M12 19 7 27M22 9l6-6M23 13l8-2M22 17l8 5M20 19l5 8"/></g>
<ellipse cx="16" cy="15" rx="7" ry="8"/><circle cx="13.5" cy="12.5" r="1.4"/><circle cx="18.5" cy="12.5" r="1.4"/></svg>`;

function seen() {
    const key = KEY + ":" + location.pathname;
    try {
        if (sessionStorage.getItem(key)) return true;
        sessionStorage.setItem(key, "1");
    } catch (e) { /* storage blocked: show them anyway */ }
    return false;
}

// A point just off one edge of the screen: 0 top, 1 right, 2 bottom, 3 left.
function edgePoint(edge, w, h) {
    const r = 0.15 + Math.random() * 0.7;
    return [[r * w, -40], [w + 40, r * h], [r * w, h + 40], [-40, r * h]][edge];
}

export default function crawl(count) {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (!document.body.animate) return;

    // Wait until someone can see the page (not a background tab)
    if (document.visibilityState !== "visible") {
        document.addEventListener("visibilitychange", function once() {
            if (document.visibilityState !== "visible") return;
            document.removeEventListener("visibilitychange", once);
            crawl(count);
        });
        return;
    }
    if (new URLSearchParams(location.search).get("season") !== "on" && seen()) return;

    const layer = document.createElement("div");
    layer.className = "gg-crawl";
    layer.setAttribute("aria-hidden", "true");
    document.body.append(layer);

    const w = window.innerWidth;
    const h = window.innerHeight;
    let left = count;

    for (let i = 0; i < count; i++) {
        const el = document.createElement("span");
        el.className = "gg-crawl__spider";
        el.innerHTML = SPIDER;
        el.style.width = 26 + Math.round(Math.random() * 14) + "px";
        layer.append(el);

        const from = i % 4;
        const to = (from + 1 + Math.floor(Math.random() * 3)) % 4;
        const [x1, y1] = edgePoint(from, w, h);
        const [x2, y2] = edgePoint(to, w, h);
        // A pause partway, the way spiders stop and start
        const mx = x1 + (x2 - x1) * 0.45 + (Math.random() - 0.5) * 80;
        const my = y1 + (y2 - y1) * 0.45 + (Math.random() - 0.5) * 80;
        const a1 = Math.atan2(my - y1, mx - x1) * 180 / Math.PI + 90;
        const a2 = Math.atan2(y2 - my, x2 - mx) * 180 / Math.PI + 90;
        const at = (x, y, a) => `translate(${x}px, ${y}px) rotate(${a}deg)`;

        const run = el.animate([
            { transform: at(x1, y1, a1), offset: 0 },
            { transform: at(mx, my, a1), offset: 0.4 },
            { transform: at(mx, my, a2), offset: 0.55 },
            { transform: at(x2, y2, a2), offset: 1 },
        ], {
            duration: 4200 + Math.random() * 2400,
            delay: 600 + i * 900,
            easing: "ease-in-out",
            fill: "both",
        });
        run.onfinish = () => {
            el.remove();
            if (--left === 0) layer.remove();
        };
    }
}
